import TrashIcon from '@heroicons/react/24/outline/TrashIcon';

import { Button } from '@/components/core/Button';
import { Dialog, DialogBody, DialogContent, DialogFooter, DialogHeader, DialogHeaderDefault } from '@/components/core/Dialog';
import { useTranslation } from '@/hooks/useTranslation';

interface DamRemoveLinkDialogProps {
    /** Description of the linked article. */
    article: string;
    isRemoving: boolean;
    onConfirm: () => void;
    onClose: () => void;
}

/** Confirmation "Remove link" (Make) before an article link of the asset is removed. */
function DamRemoveLinkDialog({ article, isRemoving, onConfirm, onClose }: DamRemoveLinkDialogProps) {
    const { t } = useTranslation();

    return (
        <Dialog open onOpenChange={(open) => !open && !isRemoving && onClose()}>
            <DialogContent variant="small">
                <DialogHeader>
                    <DialogHeaderDefault closeLabel={t('CLOSE')}>{t('DAM.DETAIL.REMOVE_LINK_TITLE')}</DialogHeaderDefault>
                </DialogHeader>
                <DialogBody className="tw-flex tw-flex-col tw-gap-4">
                    <p className="tw-m-0 tw-text-t-sm tw-text-t-primary lg:tw-text-t-base">{t('DAM.DETAIL.REMOVE_LINK_TEXT')}</p>
                    <p className="tw-m-0 tw-rounded-lg tw-bg-fill-secondary tw-p-3 tw-text-t-sm tw-text-t-primary lg:tw-text-t-base">{article}</p>
                </DialogBody>
                <DialogFooter>
                    <Button variant="outline" disabled={isRemoving} onClick={onClose}>{t('CANCEL')}</Button>
                    <Button variant="destructive" hasIcon icon={TrashIcon} loading={isRemoving} disabled={isRemoving} onClick={onConfirm}>
                        {t('DAM.DETAIL.REMOVE_LINK')}
                    </Button>
                </DialogFooter>
            </DialogContent>
        </Dialog>
    );
}

export { DamRemoveLinkDialog };
export type { DamRemoveLinkDialogProps };
